import {get} from 'lodash';

export default (state = {}, {customerId, data}: any) => {
  return {
    ...state,
    myWhy: {
      ...get(state, 'myWhy', {}),
      [customerId]: data,
    },
  };
};
